<template>
    <section class="month">
        <div class="month__name_days">
            <div class="month__title">
                {{ monthName }}    
            </div>
            <div v-for="(name,index) in nameDays"  :key="index"
                class="month__name_days--text">
                {{ name }}
            </div>
        </div>
        <div class="month__content_days">
            <div v-for="day in quantityDays" :key="day"
                class="month__content_days--number">
                <span v-if="dayCorrect(day,startDayValue) > 0"
                    :class="{ 'month__content_days--holiday' : dayIsAHoliday(dayCorrect(day,startDayValue)), 
                        'month__content_days--inalianable_holiday' : dayIsAInalianableHolidays(dayCorrect(day,startDayValue)) }"
                    @click="handleDayClick(dayCorrect(day,startDayValue))"
                    class="month_tooltip">
                    {{ dayCorrect(day,startDayValue) }}
                    <div
                        @click.stop="()=> null"
                        v-if="daySelect === `${dayCorrect(day,startDayValue)}-${month}-${year}`"
                        class="month_tooltiptext month_card_tooltip">
                        <div class="month_card_tooltip__radios">
                            <div>
                                <input v-model="radioButton" type="radio" id="holiday" name="gender" value="holiday"> 
                                <label for="holiday">Feriado</label>
                            </div>
                            <div v-if="radioButton === 'holiday'" 
                                class="month_dates">
                                <small>Hora inicio</small>
                                <date-picker v-model="min_time" 
                                    format="HH:mm"
                                    value-type="format"
                                    type="time"
                                    placeholder="HH:mm"
                                    required>
                                </date-picker>
                                <small>Hora fin</small>
                                <date-picker v-model="max_time" 
                                    format="HH:mm"
                                    value-type="format"
                                    type="time"
                                    placeholder="HH:mm"
                                    required>
                                </date-picker>
                            </div>
                            <div>
                                <input v-model="radioButton" type="radio" id="inalienable" name="gender" value="inalienable">
                                <label for="inalienable">Feriado Irrenunciable</label><br>
                            </div>
                            <div>
                                <input v-model="radioButton" type="radio" id="delete" name="gender" value="delete">
                                <label for="delete">No es feriado</label>   
                            </div>
                        </div>
                        <button 
                            @click.stop="handleClickOk(dayCorrect(day,startDayValue))"
                            class="month_card_tooltip__btn">
                            Aceptar 
                        </button>
                    </div>
                </span>
            </div>
        </div>
    </section>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: {
        date: String,
        year: Number,
        month: Number,
        monthName: String,
        holidays: Array,
        inalianableHolidays: Array,
        holidaysInfo: Array,
    },
    data: () => ({
        nameDays: [
            "lu","ma","mi","ju","vi","sa","do"
        ],
        quantityDays: 0,
        startDayValue: 0,
        start_time: '09:00',
        end_time: '16:00',
        types: [
            { text: 'Feriado', active: false },
            { text: 'Feriado Irrenunciable', active: false }
        ],
        daySelect: null,
        radioButton: null,
        min_time: null,
        max_time: null,
    }),
    components: {
        DatePicker 
    },
    mounted(){
        this.startDayValue = this.startDay(this.month, this.year) 
        this.quantityDays = this.numberDaysInMonth(this.month, this.year) 
        this.quantityDays += this.startDayValue;
    },
    methods: {
        numberDaysInMonth(month, year) {
            return new Date(year, month, 0).getDate();
        },
        startDay(month, year){
            return new Date(year, month - 1).getDay() - 1;             
        },
        handleDayClick(day){
            /* if (this.radioButton === 'holiday') { */
                this.selectTimeHoliday(day) 
            /* } */
            let html = document.querySelectorAll('.month_tooltiptext');
            const { month, year } = this
            if (this.daySelect !== `${day}-${month}-${year}`) { 
                for(let i = 0;i < html.length; i++){
                    html[i].style = "display:none;"
                }
                this.daySelect = `${day}-${month}-${year}`
            } else {
                this.daySelect = null 
            }
            this.activeRadioButton(day)
        },
        dayCorrect(day,startDayValue){
            return day - startDayValue
        },
        dayIsAHoliday(day){
            return this.holidays.some(e => e === day )
        },
        dayIsAInalianableHolidays(day){
            return this.inalianableHolidays.some(e => e === day )
        },
        clickType(num){
            num === 0 ? this.types[num + 1].active = false : this.types[num - 1].active = false  
            this.types[num].active === false ? this.types[num].active = true : this.types[num].active = false
        },
        handleClickOk(day){
            if (this.validateRadio()){ 
                const { month, year } = this
                let dayC = String(day).length <= 1 ? `0${day}` : day
                let monthC = String(month).length <= 1 ? `0${month}` : month
                let date = `${year}-${monthC}-${dayC}`
                let min_time = null
                let max_time = null
                let radio = this.radioButton
                switch(radio) {
                    case 'holiday':
                        var startHour = this.min_time.split(":")
                        let format_date = new Date(date + " 00:00:00")
                        let arr = format_date.toISOString();   
                        let offset = new Date().getTimezoneOffset()
                        var mix_date = new Date(new Date(arr).getTime() + (offset * 60000) )
                        min_time = this.mixDateHour(mix_date,Number(startHour[0]),Number(startHour[1]))
                        var endHour = this.max_time.split(":") 
                        max_time = this.mixDateHour(mix_date,Number(endHour[0]),Number(endHour[1]))
                        break;
                    case 'inalienable':
                        min_time = null; 
                        max_time = null; 
                        break;
                    case 'delete':
                        // code block
                        break;
                }
                let html = document.querySelectorAll('.month_tooltiptext');
                for(let i = 0;i < html.length; i++){
                    html[i].style = "display:none;"
                }
                this.radioButton = null
                return this.$emit('day-click',  { date: date, min_time: min_time, max_time: max_time, holiday_type: radio, time_zone: '' }) 
            }
        },
        mixDateHour(date,hour,minutes){
            let myDate = date 
            myDate.setHours(hour) 
            myDate.setMinutes(minutes)
            
            let offset = new Date().getTimezoneOffset()              
            let a = new Date().toLocaleString("ja", {timeZone: localStorage.getItem('selected_time_zone')}).split(/[/\s:]/);
            a[1] = a[1]-1;
            let t1 = Date.UTC.apply(null, a);
            let t2 = new Date().setMilliseconds(0);  
            let bookingOffset = ((t2 - t1) / 60 / 1000); 
            let ans = new Date(myDate.getTime() - (offset*60000) + (bookingOffset*60000))

            return ans.toJSON();
        },
        selectTimeHoliday(day){
            const { month, year } = this
            let dayC = String(day).length <= 1 ? `0${day}` : day
            let monthC = String(month).length <= 1 ? `0${month}` : month
            let date = `${year}-${monthC}-${dayC}`
            let holiday = this.holidaysInfo.find(h => h.date === date);  
            if (holiday !== undefined){
                this.min_time = this.setTimeFilter(holiday.min_time)
                this.max_time = this.setTimeFilter(holiday.max_time)
            } else {
                this.min_time = '09:00'
                this.max_time = '14:00'   
            }           
        },
        setTimeFilter(value){
            let s_date = new Date(value)
            let clientOffset = new Date().getTimezoneOffset()
            let timeInZone = s_date.toLocaleString('en-GB', { timeZone: localStorage.getItem('selected_time_zone') })
            let hour = timeInZone.split(", ")[1]
            let realHour = hour.split(":")
            let time = String(realHour[0]+":"+ realHour[1])
            return time
        },
        activeRadioButton(day){
            if (this.dayIsAHoliday(day)) {   
                this.radioButton = 'holiday'
            } else if(this.dayIsAInalianableHolidays(day)) {
                this.radioButton = 'inalienable'
            } else {
                this.radioButton = 'delete'
            }
        },
        validateRadio(){
            let value = false
            switch(this.radioButton) {
            case 'holiday':
                if (String(this.min_time).length > 0 && String(this.max_time).length > 0){
                    value = true
                } 
                break;
            case 'inalienable':
                value = true
                break;
            case 'delete':
                value = true
                break;
            }
            return value
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/locations/Month.vue